import styled from 'styled-components';
import Button from 'au-gatsby-ds/components/Button';
import StickyContainer from 'au-gatsby-ds/components/StickyContainer';
import { P2 } from 'au-gatsby-ds/components';

export const StickyCTAContainer = styled(StickyContainer)`
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(4px);
  left: 0;
  padding-bottom: 20px;
  height: 121px;
`;

export const ThumbnailContainer = styled.div`
  display: flex;
  min-width: 96px;
  width: 96px;
  height: 96px;
  flex-wrap: wrap;
  position: relative;
`;

export const ImageBottomBorder = styled.div`
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
`;

export const ExpandButton = styled(Button)`
  width: 20px;
  height: 20px;
  background-color: #fff;
  position: absolute;
  border-radius: 50%;
  right: 6px;
  top: 6px;
  border: 0;
`;

export const RightSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 0 16px;
`;

export const CTAMessagingWrapper = styled.span`
  ${P2}

  margin-bottom: 8px;
  letter-spacing: -0.25px;
  line-height: 18px;
  text-align: center;
  color: #757575;
`;

export const CTAButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: black;
  text-transform: none;

  &:active > span:not(.crossedOutPrice) {
    font-weight: bold;
    color: #fff;
  }

  @media (hover: hover) {
    :hover {
      background-color: transparent;
      border: 1.5px solid #000;
      color: #000;
    }

    &:hover > span:not(.crossedOutPrice) {
      font-weight: bold;
      color: #fff;
    }
  }
`;

export const ButtonText = styled.span`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
  letter-spacing: 0.5px;

  &.crossedOutPrice {
    ${P2}
    text-decoration-line: line-through;
    color: #bdbdbd;
  }

  &.disabled {
    font-weight: bold;
    color: #fff;
  }
`;
